/**
 * ajax封装
 */
import axios from 'axios';
import { Toast } from 'vant';
import local from '@/utils/local';
import {tansParams,blobValidate} from "@/utils/ruoyi";
import config from '@/config';

axios.defaults.baseURL = config.baseURL // 默认ajax请求服务器路径
axios.defaults.timeout = 30000 // 请求超时时间

// 请求拦截器
var load = null;
axios.interceptors.request.use(
  (config) => {
    load=Toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true,
    });
    // config是请求配置对象
    const token = local.get('t_k')
    // 请求头统一携带token
    if (token) {
      config.headers.access_token = token
    }
    // get请求映射params参数
    if (config.method === 'get' && config.data) {
      let url = config.url + '?' + tansParams(config.data);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config
  },(err) => {
    return Promise.reject(err)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    Toast.clear();  // 清除加载
    // resposne后端响应的数据
    const res = response.data
    // 统一处理状态码
    if (res.code === 105) {
      Toast('登录过期 ,请重新登录')
      local.clear()
      window.location.href = '/' // 跳转到登录页面
    }
    return res
  },(err) => {
    Toast.clear();  // 清除加载
    return Promise.reject(err)
  }
)

// 暴露出去
export default axios
